import { iodine } from './validation';
import { ApiError, send } from './api';
import { FormValidation } from '../types/form';
import { sendEventDataLayer, sendLpForm } from "../alpine/include/taggage";
import { addQwamplifyToFormData, addUtmToFormData } from "./form";
import { storeLocatorAutocomplete } from "./storeLocator";
import { AlpineComponentTryba } from '../alpine/include/global';

export interface ExpressFormAlpine extends AlpineComponentTryba {
    currentStepIndex: number;
    confirmation: boolean;
    errorMessages: { [key in string]: string }[];
    buttonDisable: boolean;
    loading: boolean;
    init: () => void;
    initFloatingLabels: () => void;
    firstStepFirstLastName: () => void;
    secondStepAddressZip: (domItem: HTMLElement) => void;
    checkValidation: (validation: FormValidation) => void;
    validateManually: (submitButton: HTMLButtonElement) => void;
    nextStep: () => void;
    prevStep: () => void;
    lastStep: () => Promise<void>;
}

export function getExpressSteps(form, rules, fromLanding?): ExpressFormAlpine {
    return {
        isFromLanding: fromLanding,
        currentStepIndex: 0,
        confirmation: false,
        errorMessages: [],
        buttonDisable: true,
        loading: false,
        serverMessages: [],
        _lastValidatedZip: null as string | null,
        _lastZipValid: false,
        init(): void {
            this.initFloatingLabels()
            if (this.isFromLanding) {
                // Run send data layer function
                this.sendDataLayer(document.querySelector('body')?.getAttribute('data-type'), 'etape' + this.currentStepIndex)
            }
        },
        initFloatingLabels(): void {
            (this.$refs.form.querySelectorAll('.input-group') as NodeListOf<HTMLDivElement>).forEach((element: HTMLDivElement) => {
                const input = element.querySelector('input');
                if (input) {
                    input.addEventListener('focus', () => {
                        element.classList.add('floating-label')
                    })
                    input.addEventListener('blur', () => {
                        if (input.value.trim() === "") {
                            element.classList.remove('floating-label')
                        }
                    })
                }

            });
        },
        firstStepFirstLastName() {
            const firstname = this.$refs.firstname as HTMLInputElement;
            const lastname = this.$refs.lastname as HTMLInputElement;
            const validation = iodine.assert(
                {
                    firstname: firstname.value,
                    lastname: lastname.value,
                },
                {
                    firstname: rules.firstname,
                    lastname: rules.lastname,
                },
            );
            this.checkValidation(validation);
        },
        firstStepZipValidate(firstname, lastname, validAdress, zip, phone, email) {
            const validation = iodine.assert(
                {
                    firstname: firstname.value,
                    lastname: lastname.value,
                    zip: validAdress ? zip.value : null,
                    phone: phone.value,
                    email: email.value,
                },
                {
                    firstname: rules.firstname,
                    lastname: rules.lastname,
                    zip: rules.zip,
                    phone: rules.phone,
                    email: rules.email
                },
            );
            this.checkValidation(validation);
        },

        //Validate all fields
        firstStepFirstLastNameZip(fromZip = false) {
            const actualForm = this.form.closest('form')
            const phone = actualForm.querySelector('[name$="[phone]"]');
            const email = actualForm.querySelector('[name$="[email]"]');
            const firstname = this.$refs.firstname as HTMLInputElement;
            const lastname = this.$refs.lastname as HTMLInputElement;
            const zipCode = this.form.querySelector('[name$="[zip]"]') as HTMLInputElement;

            // Fast path: called from firstname/lastname/phone/email, zip unchanged
            if (!fromZip && this._lastValidatedZip === zipCode.value) {
                this.firstStepZipValidate(firstname, lastname, this._lastZipValid, zipCode, phone, email);
                return;
            }

            // Zip blur: setTimeout lets setInfosInExpressForms update zipCode.value first,
            // then validate against already-loaded autocomplete results
            setTimeout(() => {
                let validAdress = false;
                if (this.results) {
                    const allResult = JSON.parse(JSON.stringify(this.results));
                    allResult.forEach((el) => {
                        if (el.codesPostaux.length > 1)
                            el.codesPostaux.forEach((subEl) => {
                                if (zipCode?.value == subEl + ' ' + el.nom) validAdress = true;
                            });
                        else {
                            if (zipCode?.value == el.codesPostaux[0] + ' ' + el.nom) validAdress = true;
                        }
                    });
                }
                this._lastValidatedZip = zipCode.value;
                this._lastZipValid = validAdress;
                this.firstStepZipValidate(firstname, lastname, validAdress, zipCode, phone, email);
            }, 300);
        },
        // for express form block
        secondStepAddressZipExpressVerified(domItem: HTMLElement) {
            const actualForm = domItem.closest('form')
            let validAdress = false;

            if (actualForm) {
                const zipInput = actualForm.querySelector<HTMLInputElement>('[name$="[zip]"]');
                // setTimeout because there is a delay between input.value and click at the autocomplete results which push result as input value
                setTimeout(() => {
                    const allResult = this.results = JSON.parse(JSON.stringify(this.results));
                    allResult.forEach(el => {
                        if (el.codesPostaux.length > 1)
                            el.codesPostaux.forEach(subEl => {
                                const result = subEl + ' ' + el.nom
                                if (zipInput && zipInput.value == result) {
                                    validAdress = true;
                                }
                            })
                        else {
                            const result = el.codesPostaux[0] + ' ' + el.nom
                            if (zipInput && zipInput.value == result) {
                                validAdress = true;
                            }
                        }
                    })

                    const validation = iodine.assert(
                        {
                            zip: (validAdress && zipInput) ? zipInput.value : null,
                        },
                        {
                            zip: rules.zip_no_autocomplete,
                        },
                    );
                    this.checkValidation(validation);

                }, 600)
            }
        },
        // special function to validate ZIP just with a value defined in autocomplete results
        secondStepAddressZipVerified(domItem: HTMLElement) {
            const actualForm = domItem.closest('form')
            let validAdress = false;

            if (actualForm) {
                const zipInput = actualForm.querySelector<HTMLInputElement>('[name$="[zip]"]');
                const email = actualForm.querySelector<HTMLInputElement>('[name$="[email]"]');
                const phone = actualForm.querySelector<HTMLInputElement>('[name$="[phone]"]');
                // setTimeout because there is a delay between input.value and click at the autocomplete results which push result as input value
                setTimeout(() => {
                    const allResult = this.results = JSON.parse(JSON.stringify(this.results));
                    allResult.forEach(el => {
                        if (el.codesPostaux.length > 1)
                            el.codesPostaux.forEach(subEl => {
                                const result = subEl + ' ' + el.nom
                                if (zipInput && zipInput.value == result) {
                                    validAdress = true;
                                }
                            })
                        else {
                            const result = el.codesPostaux[0] + ' ' + el.nom
                            if (zipInput && zipInput.value == result) {
                                validAdress = true;
                            }
                        }
                    })

                    const validation = iodine.assert(
                        {
                            zip: validAdress && zipInput ? zipInput.value : null,
                            email: email && email.value ? email.value : null,
                            phone: phone && phone.value ? phone.value : null
                        },
                        {
                            zip: rules.zip_no_autocomplete,
                            email: rules.email,
                            phone: rules.phone
                        },
                    );
                    this.checkValidation(validation);

                }, 600)
            }
        },
        secondStepAddressZip(domItem: HTMLElement, cityRequired = false): void {
            const actualForm = domItem.closest('form')
            if (actualForm) {
                const addressInput = actualForm.querySelector<HTMLInputElement>('[name$="[address]"]');
                const zipInput = actualForm.querySelector<HTMLInputElement>('[name$="[zip]"]');
                //Wait at click to fill input with dropdown value
                setTimeout(() => {
                    if (zipInput && zipInput.dataset.rulesOverride !== undefined) {
                        try {
                            rules.zip = JSON.parse(zipInput.dataset.rulesOverride.replaceAll('&quot;', '"'));
                        } catch (e) { /* ignore */ }
                    }
                    if (cityRequired) {
                        const cityInput = actualForm?.querySelector<HTMLInputElement>('[name$="[city]"]');
                        const validation = iodine.assert(
                            {
                                city: cityInput && cityInput.value ? cityInput.value : null,
                                zip: zipInput && zipInput.value ? zipInput.value : null,
                            },
                            {
                                city: rules.city,
                                zip: rules.zip_no_autocomplete,
                            },
                        );
                        this.checkValidation(validation);
                    }
                    else if (addressInput && zipInput) {
                        const validation = iodine.assert(
                            {
                                address: addressInput.value,
                                zip: zipInput.value,
                            },
                            {
                                address: rules.address,
                                zip: rules.zip,
                            },
                        );
                        this.checkValidation(validation);
                    } else if (addressInput == null && zipInput) {
                        const validation = iodine.assert(
                            {
                                zip: zipInput.value,
                            },
                            {
                                zip: rules.zip,
                            },
                        );
                        this.checkValidation(validation);
                    }
                }, 300)
            }
        },
        checkValidation(validation: FormValidation): void {
            if (validation.valid) {
                this.buttonDisable = false;
            } else {
                this.buttonDisable = true;
            }
        },


        validateManuallyExternal(submitButton: HTMLButtonElement): void {
            this.errorMessages = [];
            let address;
            const firstname = this.$refs.firstname as HTMLInputElement;
            const lastname = this.$refs.lastname as HTMLInputElement;
            if (this.$refs.address as HTMLInputElement) {
                address = this.$refs.address as HTMLInputElement;
            }
            // as zip is in x-data=simpleAutocomplete, it is not accessible in refs any more
            const zip = form.querySelector('[name$="[zip]"]') as HTMLInputElement;
            const city = form.querySelector('[name$="[city]"]') as HTMLInputElement;
            const phone = this.$refs.phone_custom as HTMLInputElement;
            const email = this.$refs.email as HTMLInputElement;

            const expressItems = {
                firstname: firstname.value,
                lastname: lastname.value,
                zip: zip.value,
                city: city.value,
                phone_custom: phone.value,
                email: email.value,
            };

            const expressRules = {
                firstname: rules.firstname,
                lastname: rules.lastname,
                zip: rules.zip,
                city: rules.city,
                phone_custom: rules.phone_custom,
                email: rules.email,
            };

            if (address) {
                expressItems['address'] = address.value;
                expressRules['address'] = rules.address;
            }

            let quotationItems = {};
            let quotationRules = {};

            if (form.name.includes('express_quotation') && this.$refs.projectType !== null && this.$refs.projectType !== undefined) {
                quotationItems = {
                    projectType: this.$refs.projectType.selectedOptions[0].value,
                };
                quotationRules = {
                    projectType: rules.projectType,
                };
            }

            const validation = iodine.assert({ ...expressItems, ...quotationItems }, { ...expressRules, ...quotationRules });

            if (validation.valid) {
                submitButton.disabled = true;
                this.replaceFormNameByZero(form);
                form.submit();
            } else {
                submitButton.disabled = true;
                this.displayErrors(validation);
            }
        },
        // Bottom landing form manually zip validation (check if zip value is in autocomplete result)
        validateManuallyZip(submitButton: HTMLButtonElement): void {
            let validAdress = false;
            this.errorMessages = [];
            let address;
            const firstname = this.$refs.firstname as HTMLInputElement;
            const lastname = this.$refs.lastname as HTMLInputElement;
            if (this.$refs.address as HTMLInputElement) {
                address = this.$refs.address as HTMLInputElement;
            }
            // as zip is in x-data=simpleAutocomplete, it is not accessible in refs any more
            const zip = form.querySelector('[name$="[zip]"]') as HTMLInputElement;
            const phone = this.$refs.phone as HTMLInputElement;
            const email = this.$refs.email as HTMLInputElement;

            if (zip) {
            storeLocatorAutocomplete(zip.value)
                .then((cities) => {
                    this.results = cities;
                    const allResult = (this.results = JSON.parse(JSON.stringify(this.results)));
                    allResult.forEach((el) => {
                        if (el.codesPostaux.length > 1)
                            el.codesPostaux.forEach((subEl) => {
                                const result = subEl + ' ' + el.nom;
                                if (zip.value == result) {
                                    validAdress = true;
                                }
                            });
                        else {
                            const result = el.codesPostaux[0] + ' ' + el.nom;
                            if (zip.value == result) {
                                validAdress = true;
                            }
                        }
                    });

                    this.validateManuallyZipFunction(firstname, validAdress, lastname, address, zip, phone, email, submitButton);
                })

                .catch(() => {
                    this.validateManuallyZipFunction(firstname, validAdress, lastname, address, zip, phone, email, submitButton);
                });
            }
        },
        // Bottom landing form manually zip validation, validation

        validateManuallyZipFunction (firstname, validAdress, lastname, address, zip, phone, email, submitButton) {
            const expressItems = {
                firstname: firstname.value,
                lastname: lastname.value,
                zip: validAdress ?  zip.value : null,
                phone: phone.value,
                email: email.value,
            };

            const expressRules = {
                firstname: rules.firstname,
                lastname: rules.lastname,
                zip: rules.zip,
                phone: rules.phone,
                email: rules.email,
            };

            if (address) {
                expressItems['address'] = address.value;
                expressRules['address'] = rules.address;
            }

            let quotationItems = {};
            let quotationRules = {};

            if (form.name.includes('express_quotation') && this.$refs.projectType !== null && this.$refs.projectType !== undefined) {
                quotationItems = {
                    projectType: this.$refs.projectType.selectedOptions[0].value,
                };
                quotationRules = {
                    projectType: rules.projectType,
                };
            }

            const validation = iodine.assert({ ...expressItems, ...quotationItems }, { ...expressRules, ...quotationRules });

            if (validation.valid) {
                submitButton.disabled = true;
                this.replaceFormNameByZero(form);
                form.submit();
            } else {
                submitButton.disabled = false;
                this.displayErrors(validation);

                if (validAdress == false) {
                    this.errorMessages['zip'] = 'Veuillez saisir une adresse valide'
                }
            }
        },
        validateManually(submitButton: HTMLButtonElement): void {
            this.errorMessages = [];
            let address;
            const firstname = this.$refs.firstname as HTMLInputElement;
            const lastname = this.$refs.lastname as HTMLInputElement;
            if (this.$refs.address as HTMLInputElement) {
                address = this.$refs.address as HTMLInputElement;
            }
            // as zip is in x-data=simpleAutocomplete, it is not accessible in refs any more
            const zip = form.querySelector('[name$="[zip]"]') as HTMLInputElement;
            const phone = this.$refs.phone as HTMLInputElement;
            const email = this.$refs.email as HTMLInputElement;

            const expressItems = {
                firstname: firstname.value,
                lastname: lastname.value,
                zip: zip.value,
                phone: phone.value,
                email: email.value,
            };

            const expressRules = {
                firstname: rules.firstname,
                lastname: rules.lastname,
                zip: rules.zip,
                phone: rules.phone,
                email: rules.email,
            };

            if (address) {
                expressItems['address'] = address.value;
                expressRules['address'] = rules.address;
            }

            let quotationItems = {};
            let quotationRules = {};

            if (form.name.includes('express_quotation') && this.$refs.projectType !== null && this.$refs.projectType !== undefined) {
                quotationItems = {
                    projectType: this.$refs.projectType.selectedOptions[0].value,
                };
                quotationRules = {
                    projectType: rules.projectType,
                };
            }

            const validation = iodine.assert({ ...expressItems, ...quotationItems }, { ...expressRules, ...quotationRules });

            if (validation.valid) {
                submitButton.disabled = true;
                this.replaceFormNameByZero(form);
                form.submit();
            } else {
                submitButton.disabled = false;
                this.displayErrors(validation);
            }
        },
        nextStep() {
            this.currentStepIndex++;
            const formPosition = this.form.getBoundingClientRect().top + window.scrollY;
            if (this.$store.global.isMobile) {
                if (this.currentStepIndex == 3) {
                    window.scrollTo({
                        top: formPosition + 100,
                        left: 0,
                        behavior: 'smooth'
                    });
                } else {
                    window.scrollTo({
                        top: formPosition,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            }
            if (this.currentStepIndex == 1) {
                this.secondStepAddressZip(form)
            }
            if (this.currentStepIndex == 2) {
                if (form.name.includes('express_appointment_form')) {
                    this.thirdStepAppointment()
                } else {
                    this.thirdStepQuotation()
                }
            }
            if (this.currentStepIndex == 3) {
                this.fourthStepQuotation()
            }
            this.errorMessages = [];

            if (this.isFromLanding) {
                // Run send data layer function
                this.sendDataLayer(document.querySelector('body')?.getAttribute('data-type'), "etape" + this.currentStepIndex)
            }
            this.sendEvent(document.querySelector('body')?.getAttribute('data-type'), form.name, this.currentStepIndex + 1)

        },
        prevStep() {
            this.serverMessages = [];
            this.currentStepIndex--;
            if (this.currentStepIndex == 1) {
                this.secondStepAddressZip(form)
            }
            if (this.currentStepIndex == 2) {
                if (form.name == 'express_appointment_form') {
                    this.thirdStepAppointment()
                } else {
                    this.thirdStepQuotation()
                }
            }
            if (this.currentStepIndex == 3) {
                this.fourthStepQuotation()
            }
            if (this.isFromLanding) {
                // Run send data layer function
                this.sendDataLayer(document.querySelector('body')?.getAttribute('data-type'), "etape" + this.currentStepIndex)
            }
        },
        replaceFormNameByZero(form: HTMLFormElement): void {
            /**
             * Remplace toutes les  occurences  de "express_quotation_form3" par "express_quotation_form0"
             * dans les attributs [name] des inputs enfants du formulaire afin de
             * correspondre avec la déclaration faite dans le controller back
             */
            const formNumberKey = form.name.match(/\d+/);
            if (formNumberKey !== null) {
                form.name = form.name.replace(`${formNumberKey}`, '0');
                Array.from(form.querySelectorAll('[name^="express_"]')).forEach((element: Element) => {
                    element.setAttribute('name', (element.getAttribute('name') as string).replace('form' + formNumberKey, 'form0'));
                })
            }
        },
        async lastStep() {
            if (this.loading) {
                return;
            }
            this.buttonDisable = true;
            this.loading = true;
            if (this.isFromLanding) {
                sendEventDataLayer('page', "", "", '/landing/form/confirmation')
            }
            if (form) {
                this.replaceFormNameByZero(form);
                const formData = new FormData(form);
                addUtmToFormData(formData, form.name);
                addQwamplifyToFormData(formData, form.name);

                try {
                    await send(formData, this.isFromLanding ? form.action + '?is_landing_page=true' : form.action);
                    this.confirmation = true;
                    this.loading = false;
                    this.buttonDisable = false;
                    if (form.action.includes("appointment")) {
                        if (this.isFromLanding) {
                            form.setAttribute('data-tracking', 'confirmation-landing-rdv-express')
                        } else {
                            form.setAttribute('data-tracking', 'confirmation-rdv-express')
                        }
                    }
                    if (form.action.includes("quotation")) {
                        if (this.isFromLanding) {
                            form.setAttribute('data-tracking', 'confirmation-landing-devis-express')
                        } else {
                            form.setAttribute('data-tracking', 'confirmation-devis-express')
                        }
                    }
                    window.localStorage.removeItem('utm_source');
                    window.localStorage.removeItem('utm_campaign');
                    window.localStorage.removeItem('qwp_id');
                } catch (e: unknown) {
                    const err = e as ApiError;
                    this.serverMessages = [];
                    Object.keys(err).forEach(k => {
                        this.serverMessages.push(...err[k])
                    })
                    this.confirmation = false;
                    this.loading = false;
                    this.buttonDisable = false;
                } finally {
                    this.buttonDisable = false;
                    //Send to data Layer confirmation page from express form
                    this.sendDataLayer(document.querySelector('body')?.getAttribute('data-type'), 'confirmation')
                    sendEventDataLayer('click', document.querySelector('body')?.getAttribute('data-type'), form.name, this.currentStepIndex + 2)
                }
            }
        },
        ///////////////
        /// Send data to dataLayer
        ///////////////
        sendDataLayer(other?: number | string | null | any, step?: number | string | null | any) {
            sendLpForm(
                { slot1: other, slot2: step },
                { categoryName: other },
            )
        },
        sendEvent(pageName: string, form: any, step: any) {
            sendEventDataLayer('click', pageName, form, step)
        }
    };
}
